// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserSetup.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
/**
 * User Setup component
 */
import React, { PropTypes, Component } from 'react';
import { observe } from 'mobx';
import connect from 'share/enhancers/Izenda.Connect';
import LazyLoading from 'share/components/controls/LazyLoading/Izenda.LazyLoading';
import { observer, propTypes as MobxPropTypes } from 'mobx-react';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

import UserItem from 'modules/Settings/UserSetup/MiddlePanel/Izenda.UserItem';
import Detail from './UserSetupDetail/Izenda.UserSetupDetail';
import MiddlePanel from 'share/components/layout/Izenda.MiddlePanel';
import Header from './MiddlePanel/Izenda.UserSetupHeader';
import UserSetupDetail from './UserSetupDetail/Izenda.UserSetupDetail';
import UserAccountStore from 'logic/Izenda.UserAccountStore';
import UIContants from 'logic/data/Izenda.UIConstants';
import { get } from 'lodash/fp';
const USER_ITEM_HEIGHT = 37;
@connect()
class UserSetup extends Component {
  static PropTypes = {
    store: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    let { loader } = props;

    this.store = new UserAccountStore();
    this.registerLazyLoadingStore = this.store.registerLazyLoadingStore.bind(this.store);
    this.loadData = () => {
      loader.startLoading();
      return this.store.loadAllUserSetup().finally(loader.endLoading.bind(loader));
    };
  }

  componentWillMount() {
    this.store.init();
    this.loadData();
    let { loader } = this.props;

    this.disposeChangeTenant = observe(this.store, 'tenantId', () => {
      loader.startLoading();
      this.loadData()
        .then(this.store.getPartialUsers.bind(this.store, null, true))
        .finally(loader.endLoading.bind(loader));
    });
  }

  componentWillUnMount() {
    this.store.destroy();
    this.disposeChangeTenant();
  }

  /**
   * Render User Item
   * @param {Object} item
   */
  renderUserItem = (item: Object) => {
    const { authorization, authorizationConstants } = this.props;
    const readOnly = !authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit]);

    return <UserItem userInfo={item} store={this.store} key={item.id} readOnly={readOnly} />;
  };

  /**
   * Get Data for lazy loading
   * @param {Object} pageInfo
   * @param {boolean} isSearching
   */
  getData = (pageInfo: Object, isSearching: boolean) => {
    let { loader } = this.props;
    const isFirstLoad = pageInfo && get('fromIndex', pageInfo) === 0;
    isFirstLoad && loader.startLoading();
    return this.store.getPartialUsers(pageInfo, isSearching).finally(loader.endLoading.bind(loader));
  };

  /**
   * Search user list - search lazy
   * @param {String} searchKey
   */
  searchUser = (searchKey: String) => {
    const model = get('store.model', this);

    model.updateFilterText(searchKey);
    return this.store.getPartialUsers(null, true, searchKey);
  };

  render() {
    const { authorization, authorizationConstants } = this.props;
    const store = this.store;
    const model = store.model;
    const readOnly = !authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit]);

    return (
      <div className="izenda-TableLayout">
        <MiddlePanel minWidth={0} maxWidth={250}>
          <div className="u_fullHeight u-posRelative u-bgWhite">
            <div className="izenda-MiddlePanel-search">
              <Header store={store} searchUser={this.searchUser} />
            </div>
            <div className="izenda-MiddlePanel-content">
              <ScrollBox>
                <LazyLoading
                  data={model.filterUser}
                  isLastPage={model.isLastPage}
                  getData={this.getData}
                  renderItem={this.renderUserItem}
                  viewHeight={UIContants.MIDDLE_PANEL_LIST_MAX_HEIGHT}
                  itemHeight={USER_ITEM_HEIGHT}
                  registerLazyLoadingStore={this.registerLazyLoadingStore}
                  itemKey="id"
                />
              </ScrollBox>
            </div>
          </div>
        </MiddlePanel>

        <div className="izenda-TableLayout-Cell">
          {store.configUserCloned ? <UserSetupDetail store={store} readOnly={readOnly} /> : null}
        </div>
      </div>
    );
  }
}

export default UserSetup;



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/Izenda.UserSetup.js